import dayjs, { Dayjs } from "dayjs";

export const normalizeFormDate = (value: unknown): Date | null => {
  if (value == null || value === "") {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (dayjs.isDayjs(value)) {
    return value.isValid() ? value.toDate() : null;
  }

  const raw = String(value);

  if (raw === "0") {
    return null;
  }

  const numericPattern = /^\d+$/;

  if (numericPattern.test(raw)) {
    const date = new Date(Number(raw));
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const toPickerDate = (value: unknown): Dayjs | null => {
  const date = normalizeFormDate(value);
  if (!date) {
    return null;
  }

  const parsed = dayjs(date);
  return parsed.isValid() ? parsed : null;
};

export const fromPickerDate = (value: unknown): Date | null => {
  if (value == null) {
    return null;
  }

  if (dayjs.isDayjs(value)) {
    return value.isValid() ? value.toDate() : null;
  }

  return normalizeFormDate(value);
};
